// IE Hub - Support and FAQ's Page
// Thin wrapper that renders the reusable SupportAndFaqs component inside DashboardLayout

import { useState } from 'react';
import DashboardLayout from '@/components/DashboardLayout';
import ContactUsDialog from '@/components/ContactUsDialog';
import { SupportAndFaqs } from '@/features/supportFaqs';

function SupportAndFaqsPage() {
  const [contactDialogOpen, setContactDialogOpen] = useState(false);

  const handleContactSupport = () => {
    setContactDialogOpen(true);
  };

  const handleContactClose = () => {
    setContactDialogOpen(false);
  };

  return (
    <DashboardLayout backgroundColor="#f8f9fa">
      <SupportAndFaqs onContactSupport={handleContactSupport} />
      <ContactUsDialog
        open={contactDialogOpen}
        onClose={handleContactClose}
      />
    </DashboardLayout>
  );
}

export default SupportAndFaqsPage;
